import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const WatchlistPhaseLoader = ({ className }) => {
  const [isLongLoading, setIsLongLoading] = useState(false);
  const step = useSelector((state) => state.watchlistReducer.wlPageLoadingStep);
  const showWatchlistStub = useSelector((state) => state.watchlistReducer.showWatchlistStub);
  const sharedWatchlistStubPage = useSelector((state) => (
    state.watchlistReducer.sharedWatchlistStubPage
  ));
  const showStub = showWatchlistStub || sharedWatchlistStubPage;

  const message = useMemo(() => {
    const messagesMap = {
      LOADING_WL: 'Loading watchlist data',
      LOADING_TOPICS_DATA: 'Loading data for your topics',
    };

    if (!step || step === 'LOADED' || !messagesMap[step]) {
      return null;
    }

    return messagesMap[step];
  }, [step]);

  useEffect(() => {
    setIsLongLoading(false);

    if (!message) {
      return;
    }

    const timeout = setTimeout(() => {
      setIsLongLoading(true);
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [message]);

  if (showStub || !message) {
    return null;
  }

  return (
    <div className={cx('watchlist-phase-loader', className)}>
      <div className={Styles.message}>
        {isLongLoading ? 'Apologies, it\'s taking longer than expected to load the data' : message}
      </div>
      <div className={Styles.loader} />
    </div>
  );
};

export default WatchlistPhaseLoader;
